import { queryCompany, addCompany, updateCompany, deleteCompany,selectSingleCompany,updateCompanyRole,companyBindOrg } from "../../api/config/modules/CompanyManagement";

const state = { queryCompany: {}, addCompany: {}, updateCompany: {}, deleteCompany: {}, selectSingleCompany: {}, updateCompanyRole: {}, companyBindOrg: {} };

const mutations = {
    SET_QUERYCOMPANY: (state, queryCompany) => { state.queryCompany = queryCompany },
    SET_ADDCOMPANY: (state, addCompany) => { state.addCompany = addCompany },
    SET_UPDATECOMPANY: (state, updateCompany) => { state.updateCompany = updateCompany },
    SET_DELETECOMPANY: (state, deleteCompany) => { state.deleteCompany = deleteCompany },
    SET_SELECTSINGLECOMPANY: (state, selectSingleCompany) => { state.selectSingleCompany = selectSingleCompany },
    // SET_SETPOSITION: (state, setPosition) => { state.setPosition = setPosition },
    SET_UPDATECOMPANYROLE: (state, updateCompanyRole) => { state.updateCompanyRole = updateCompanyRole },
    SET_COMPANYBINDORG: (state, companyBindOrg) => { state.companyBindOrg = companyBindOrg },
};

const actions = {
    GET_QUERYCOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            queryCompany(data)
                .then((res) => {
                    commit("SET_QUERYCOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ADDCOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            addCompany(data)
                .then((res) => {
                    commit("SET_ADDCOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATECOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateCompany(data)
                .then((res) => {
                    commit("SET_UPDATECOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETECOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteCompany(data)
                .then((res) => {
                    commit("SET_DELETECOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTSINGLECOMPANY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectSingleCompany(data)
                .then((res) => {
                    commit("SET_SELECTSINGLECOMPANY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    // GET_SETPOSITION: ({ commit }, data) => {
    //     return new Promise((resolve, reject) => {
    //         setPosition(data)
    //             .then((res) => {
    //                 commit("SET_SETPOSITION", res);
    //                 resolve(res);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //             });
    //     });
    // },
    GET_UPDATECOMPANYROLE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateCompanyRole(data)
                .then((res) => {
                    commit("SET_UPDATECOMPANYROLE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_COMPANYBINDORG: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            companyBindOrg(data)
                .then((res) => {
                    commit("SET_COMPANYBINDORG", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
